import React, { useEffect, useState } from "react";
import { Download, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { isTauri } from "@/hooks/useDesktop";

export const UpdateBanner = () => {
  const [update, setUpdate] = useState(null);
  const [pct, setPct] = useState(null);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    if (!isTauri()) return;
    import("@tauri-apps/plugin-updater").then(({ check }) => check()).then((u) => u && setUpdate(u)).catch(() => {});
  }, []);

  if (!update || hidden) return null;

  const install = async () => {
    try {
      let total = 0, got = 0;
      setPct(0);
      const { invoke } = await import("@tauri-apps/api/core");
      await update.download((e) => {
        if (e.event === "Started") total = e.data.contentLength || 0;
        if (e.event === "Progress") { got += e.data.chunkLength; if (total) setPct(Math.round(got / total * 100)); }
      });
      await invoke("stop_services");
      await update.install();
      const { relaunch } = await import("@tauri-apps/plugin-process");
      await relaunch();
    } catch (e) { setPct(null); toast.error(`Update failed: ${e}`); }
  };

  return (
    <div className="flex items-center gap-3 px-4 py-2 bg-[#E6B04E]/15 border-b border-[#E6B04E]/40 text-sm" data-testid="update-banner">
      <Download size={15} className="text-[#E6B04E]" />
      <span>AI Wedding Studio <b>{update.version}</b> is available{update.body ? ` · ${update.body}` : ""}.</span>
      <span className="metric-label">Running jobs pause and continue after the restart.</span>
      <div className="flex-1" />
      <button className="btn btn-gold !py-1 text-xs" onClick={install} disabled={pct !== null} data-testid="btn-update-install">
        {pct !== null ? <><Loader2 size={13} className="animate-spin" />{pct}%</> : "Update & restart"}</button>
      {pct === null && <button className="btn btn-ghost !p-1" onClick={() => setHidden(true)} data-testid="btn-update-later"><X size={14} /></button>}
    </div>
  );
};
